import { Link } from "react-router-dom";
import SoftwareCard from "@/components/base/SoftwareCard";
import { softwareList } from "@/mocks/software";

export default function LatestUpdates() {
  const latest = [...softwareList]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 6);

  return (
    <section className="w-full max-w-[1240px] mx-auto px-4 md:px-6 pt-14 md:pt-16">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">最新更新软件</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按发布时间倒序排列，第一时间掌握软件版本更新与动态</p>
        </div>
        <Link to="/search?q=" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
          更多更新
          <span className="flex items-center justify-center w-4 h-4"><i className="ri-arrow-right-line" aria-hidden="true"></i></span>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {latest.map((software, i) => (
          <SoftwareCard key={software.id} software={software} index={i} />
        ))}
      </div>
    </section>
  );
}